import { render, staticRenderFns } from "./ProjectViewContract.vue?vue&type=template&id=53871b64&"
import script from "./ProjectViewContract.vue?vue&type=script&lang=js&"
export * from "./ProjectViewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports